import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f29d6b7")

_pushScopeId("data-v-2f29d6b7")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 施設にログイン ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("読み込み中...")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_loading_message = _resolveComponent("loading-message")
  const _component_clinic_row = _resolveComponent("clinic-row")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content, null, {
        default: _withId(() => [
          (_ctx.fetchStatus === _ctx.FetchStatus.Fetching)
            ? (_openBlock(), _createBlock(_component_loading_message, { key: 0 }, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.clinicList, (clinic) => {
            return (_openBlock(), _createBlock(_component_clinic_row, {
              key: clinic.clinicId,
              name: clinic.name,
              owner: clinic.owner,
              invitation: clinic.invitation,
              onClick: ($event: any) => (_ctx.onLoginClinic(clinic.clinicId))
            }, null, 8, ["name", "owner", "invitation", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})